import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { CheckAuth } from 'src/Services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { ActionItemSearchModel, ActionItemSearchStatusHistoryModel, ActionItemUpdateStatusModel, userModel } from 'src/Models/TracItModel';
import { ActionStatusList } from 'src/Models/Common';
import { ActionItemService } from 'src/Services/tracit.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-action-status-popup',
  templateUrl: './action-status-popup.component.html',
  styleUrls: ['./action-status-popup.component.css']
})
export class TracItActionStatusPopupComponent implements OnInit {
  tokenKey: string = '';
  userModel: userModel[];
  actionItemUpdateStatusModel = new ActionItemUpdateStatusModel();

  dropdownUserSettings = {};
  selectedItemsUser = [];
  dropdownListUser = [];

  dropdownStatusSettings = {};
  selectedItemsStatus = [];
  dropdownListStatus = [];
  newStatus: number = -1;

  companyId: number = 0;
  userId: number = 0;
  actionId: number = 0;
  updateId: number = 0;
  productId: number = 0;
  notes: string = '';

  isHideAssignToUser: boolean = false;
  isHideRadioOption: boolean = false;
  isShowHideExrtaChargeAndNote: boolean = false;

  isOneClickOnButton: boolean = false;

  dropdownListReminder = [];
  selectedItemsReminder = [];
  dropdownSingleSettings = {};
  isReminderUser = false;
  selectedItemsReminderUsers = [];
  dropdownUsersSettings = {};


  updateActionStatus = new FormGroup({
    assignToUser: new FormControl(''),
    status: new FormControl(''),
    handleType: new FormControl(''),
    notes: new FormControl(''),
    actionID: new FormControl(''),
    updateID: new FormControl(''),
    isInformationOnly: new FormControl(false),
    briefingId: new FormControl(''),
    reminder: new FormControl(''),
    reminderUsers: new FormControl(''),
  });

  actionItemSearchModel = new ActionItemSearchModel()
  actionItemSearchStatusHistoryModel: ActionItemSearchStatusHistoryModel[];
  isActionItemSearchStatusHistoryData: boolean = false;

  stateArray: any = [];
  carrierCategoryArray: any = [];
  isAccordianShow: boolean = true;

  previousAssingId: number;
  emaliAutoLoginUserId: number = 0;
  assignToId: number = 0;
  isNoteVisible: boolean = false;

  previousStatus: number = -1;
  briefingId: number = 0;
  closeText = '';
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  constructor(private readonly toastr: ToastrService,
    private readonly actionItemServices: ActionItemService,
    private readonly checkAuth: CheckAuth,
    private readonly activeModal: NgbActiveModal,
    private sessionStorageService: SessionStorageService) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.companyId = +sessionStorage.getItem("CompanyId");
    this.userId = +sessionStorage.getItem('UserId');
    this.productId = 4;
    this.updateId = +sessionStorage.getItem('updateId');
    this.actionId = +sessionStorage.getItem('actionId');
    this.briefingId = +sessionStorage.getItem('briefingId');
    this.emaliAutoLoginUserId = +sessionStorage.getItem('emailUserId');
    this.GetAllReminders();

    this.dropdownSingleSettings = {
      singleSelection: true,
      text: "Select",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false,
    };

    sessionStorage.removeItem('productId');
    sessionStorage.removeItem('updateId');
    sessionStorage.removeItem('actionId');
    sessionStorage.removeItem('emailUserId');
    sessionStorage.removeItem('briefingId');

    this.ActionItemSearchByIds(this.userId, this.updateId, this.actionId, this.briefingId);
    this.GetActionItemSearchStatusHistory(this.userId, this.updateId, this.actionId, this.briefingId);
    this.selectedItemsReminder = this.dropdownListReminder.filter(x => x.id == 'None');
  }

  GetActionItemSearchStatusHistory(userId: any, updateId: any, actionId: any, briefingId: any) {
    this.actionItemServices.GetActionItemSearchStatusHistory(this.tokenKey, userId, updateId, actionId, briefingId).subscribe(
      data => {

        if (data['status'] == 'Success') {
          this.actionItemSearchStatusHistoryModel = data['actionItemSearchHistoryModel'];
          if (this.actionItemSearchStatusHistoryModel != null) {
            if (this.actionItemSearchStatusHistoryModel.length == 0) {
              this.isActionItemSearchStatusHistoryData = true;
            }
            else
              this.isActionItemSearchStatusHistoryData = false;

          }
        }
      });
  }

  ActionItemSearchByIds(userId: any, updateId: any, actionId: any, briefingId: any) {
    this.actionItemServices.ActionItemSearchByIds(this.tokenKey, userId, updateId, actionId, briefingId).subscribe(
      data => {

        if (data['status'] == 'Success') {
          this.actionItemSearchModel = data['actionItemSearchModel'];
          this.assignToId=Number(this.actionItemSearchModel.assignToId);

          if (this.actionItemSearchModel != null) {
            if (this.actionItemSearchModel.handleType == '2')
              this.isNoteVisible = true;
            else
              this.isNoteVisible = false;
          }
          else
            this.isNoteVisible = false;

          if (this.actionItemSearchModel != null) {
            this.isHideAssignToUser = this.actionItemSearchModel.isHideAssignToUser.toString() == 'true' ? true : false;
            this.isHideRadioOption = this.actionItemSearchModel.isHideRadioOption.toString() == 'true' ? true : false;
          }

          this.GetUsersFindByCompanyId(this.companyId);
          this.GetActionStatus();
          if (this.actionItemSearchModel.stateName != 'null' && typeof (this.actionItemSearchModel.stateName) != 'undefined') {
            this.stateArray = this.actionItemSearchModel.stateName.split(',');
          }
          if (this.actionItemSearchModel.carrierNames != 'null' && typeof (this.actionItemSearchModel.carrierNames) != 'undefined') {
            this.carrierCategoryArray = this.actionItemSearchModel.carrierNames.split(',');
          }
        }
      });
  }

  GetUsersFindByCompanyId(companyId: any) {
    this.actionItemServices.GetUsersFindByCompanyId(this.tokenKey, companyId, this.productId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.userModel = data['companyUsers'];
          if (this.userModel != null) {
            this.dropdownListUser = [];
            if (this.userModel.length > 0) {
              for (let iCounter = 0; iCounter < this.userModel.length; iCounter++) {
                this.dropdownListUser.push({ "id": parseInt(this.userModel[iCounter].userId), "itemName": this.userModel[iCounter].userName });
              }
            }
          }
        }

        this.selectedItemsUser = [];
        if (this.emaliAutoLoginUserId > 0) {
          for (let iCounter = 0; iCounter < this.userModel.length; iCounter++) {
            if (this.emaliAutoLoginUserId == parseInt(this.userModel[iCounter].userId)) {
              this.selectedItemsUser.push({ "id": parseInt(this.userModel[iCounter].userId), "itemName": this.userModel[iCounter].userName });
              this.previousAssingId = parseInt(this.userModel[iCounter].userId);
            }
          }
        }
        else {
          if (this.actionItemSearchModel.assignToId != null && this.actionItemSearchModel.assignToId != '') {
            for (let iCounter = 0; iCounter < this.userModel.length; iCounter++) {
              if (this.userModel[iCounter].userId == this.actionItemSearchModel.assignToId) {
                this.selectedItemsUser.push({ "id": parseInt(this.userModel[iCounter].userId), "itemName": this.userModel[iCounter].userName });
                this.previousAssingId = parseInt(this.userModel[iCounter].userId);
              }
            }
          }
        }

        this.dropdownUserSettings = {
          singleSelection: true,
          text: "Select User",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 3,
          noDataLabel: 'No user available',
          showCheckbox: false
        };
      });
  }

  onSelectedUser($event) {
    this.assignToId = $event.id;
  }

  onDeSelectedUser($event) {
    this.assignToId = 0;
  }

  onDeSelectedAllUser($event) {
    this.assignToId = 0;
  }

  GetActionStatus() {
    this.actionItemServices.GetActionStatus(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          let actionStatus = data['companyModel'];
          if (actionStatus != null) {
            if (actionStatus.length > 0) {
              this.dropdownListStatus = [];
              this.selectedItemsStatus = [];
              for (let iCounter = 0; iCounter < actionStatus.length; iCounter++) {
                if (parseInt(actionStatus[iCounter].statusId) != ActionStatusList.informativeonly)
                  this.dropdownListStatus.push({ "id": parseInt(actionStatus[iCounter].statusId), "itemName": actionStatus[iCounter].statusName });
              }

              if (this.actionItemSearchModel != null) {
                this.selectedItemsReminder = this.dropdownListReminder.filter(x => x.id == this.actionItemSearchModel.reminder);
                if (this.actionItemSearchModel.reminder != null)
                  this.selectedItemsReminderUsers = this.actionItemSearchModel.reminderUsers;
                if (this.actionItemSearchModel.reminder != 'None' && this.actionItemSearchModel.reminder != null)
                  this.isReminderUser = true;
              }
            }
          }

          if (this.actionItemSearchModel.statusName != null && this.actionItemSearchModel.statusName != '') {
            for (let iCounter = 0; iCounter < actionStatus.length; iCounter++) {
              if (actionStatus[iCounter].statusName == this.actionItemSearchModel.statusName) {
                this.selectedItemsStatus.push({ "id": parseInt(actionStatus[iCounter].statusId), "itemName": actionStatus[iCounter].statusName });
                this.previousStatus = parseInt(actionStatus[iCounter].statusId);
                this.newStatus = parseInt(actionStatus[iCounter].statusId);
              }
            }
          }
        }

        this.dropdownStatusSettings = {
          singleSelection: true,
          text: "Select Status",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 3,
          noDataLabel: 'No status available',
          showCheckbox: false
        };
      });
  }
  onSelectedStatus($event) {
    this.newStatus = $event.id
  }

  onDeSelectedStatus($event) {
    this.newStatus = -1
  }

  onDeSelectAllStatus($event) {
    this.newStatus = -1
  }

  UpdateActionItem(updateActionStatus: any, isButtonDisable: boolean) {
    event.preventDefault();

    if (updateActionStatus.value['updateID'] != undefined)
      this.actionItemUpdateStatusModel.updateId = updateActionStatus.value['updateID'];
    else
      this.actionItemUpdateStatusModel.updateId = 0;

    if (updateActionStatus.value['actionID'] != undefined)
      this.actionItemUpdateStatusModel.actionId = updateActionStatus.value['actionID'];
    else
      this.actionItemUpdateStatusModel.actionId = 0;

    if (updateActionStatus.value['briefingId'] != undefined)
      this.actionItemUpdateStatusModel.briefingId = updateActionStatus.value['briefingId'];
    else
      this.actionItemUpdateStatusModel.briefingId = 0;

    if (updateActionStatus.value['handleType'] != undefined && !this.isHideRadioOption)
      this.actionItemUpdateStatusModel.handleType = updateActionStatus.value['handleType'];
    else
      this.actionItemUpdateStatusModel.handleType = 0;

    this.actionItemUpdateStatusModel.assignToId = this.assignToId;

    if (this.selectedItemsReminder.length > 0)
      this.actionItemUpdateStatusModel.reminder = this.selectedItemsReminder[0].id;
    if (this.actionItemUpdateStatusModel.reminder != 'None' && this.actionItemUpdateStatusModel.reminder != undefined && this.selectedItemsReminderUsers.length == 0) {
      this.showMessage('Please select reminder users', 'Error', 'error');
      return;
    }
    if (this.actionItemUpdateStatusModel.reminder != 'None' && this.selectedItemsReminderUsers.length > 0 && !this.selectedItemsReminderUsers.find(x => x.id == this.userId)) {
      this.showMessage('You can not remove current user from reminder user', 'Error', 'error');
      return;
    }

    this.actionItemUpdateStatusModel.reminderUsers = this.selectedItemsReminderUsers;

    if (this.newStatus == -1)
      this.newStatus = ActionStatusList.pending;

    this.actionItemUpdateStatusModel.statusId = this.newStatus;

    if (this.newStatus == ActionStatusList.pending && this.previousStatus != ActionStatusList.acknowledged &&
      !this.isHideRadioOption && updateActionStatus.value['handleType'] != undefined && updateActionStatus.value['handleType'] != '0') {
      this.actionItemUpdateStatusModel.statusId = ActionStatusList.acknowledged;
    }

    this.actionItemUpdateStatusModel.userID = this.userId;

    if (updateActionStatus.value['notes'] != undefined)
      this.actionItemUpdateStatusModel.note = updateActionStatus.value['notes'];
    else
      this.actionItemUpdateStatusModel.note = '';

    this.actionItemUpdateStatusModel.productId = this.productId;
    this.actionItemUpdateStatusModel.previousAssingId = this.previousAssingId;
    this.actionItemUpdateStatusModel.previousStatus = this.previousStatus;
    this.actionItemUpdateStatusModel.briefingId = this.briefingId;

    if (isButtonDisable) {
      return;
    }

    this.isOneClickOnButton = true;

    this.actionItemServices.ActionItemUpdateStatus(this.tokenKey, this.actionItemUpdateStatusModel).subscribe(
      data => {
        this.isOneClickOnButton = false;
        if (data['status'] == 'Success') {
          this.showMessage('Trac-It status upteded successfully', 'Success', 'success');
          this.activeModal.close('Yes');
        }
        else {
          this.showMessage(data['status'], 'Error', 'error');
          this.isOneClickOnButton = false;
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
        this.isOneClickOnButton = false;
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  NoteVisible(isChecked: boolean) {
    this.isNoteVisible = isChecked;
  }

  editComplete(event) {
    this.ActionItemSearchByIds(this.userId, this.updateId, this.actionId, this.briefingId);
    this.closeText = 'Reload';
  }
  deleteComplete() {
    this.activeModal.close('Reload')
  }

  GetAllReminders() {
    this.dropdownListReminder.push({ "id": 'None', "itemName": "None" });
    this.dropdownListReminder.push({ "id": 'Before 2 months', "itemName": "Before 2 months" });
    this.dropdownListReminder.push({ "id": 'Before 1 month', "itemName": "Before 1 month" });
    this.dropdownListReminder.push({ "id": 'Before 2 weeks', "itemName": "Before 2 weeks" });
    this.dropdownListReminder.push({ "id": 'Before 1 day', "itemName": "Before 1 day" });
  }

  onChangeReminder(event) {
    this.isReminderUser = false;
    this.selectedItemsReminderUsers = [];
    if (event) {
      if (Array.isArray(event) && event.length == 0) {
        this.isReminderUser = false;
      }
      else if (event.id != 'None') {
        this.isReminderUser = true;
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.userId);
      }
    }
  }

  GetUsersFindByCompanyIdRemoveLoginUser(companyId: any) {
    this.actionItemServices.GetUsersFindByCompanyIdRemoveLoginUser(this.tokenKey, companyId, this.productId, this.userId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.userModel = data['companyUsers'];
          if (this.userModel != null) {
            if (this.userModel.length > 0) {
              for (let iCounter = 0; iCounter < this.userModel.length; iCounter++) {
                this.dropdownListUser.push({ "id": parseInt(this.userModel[iCounter].userId), "itemName": this.userModel[iCounter].userName });
              }
            }
          }
        }


        this.dropdownUsersSettings = {
          singleSelection: false,
          text: "Select User",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 3,
          noDataLabel: 'No user available',
          showCheckbox: true,
        };
      });
  }

  onSelectedReminderUser($event) {
    if (this.selectedItemsReminderUsers != null) {
      if (this.selectedItemsReminderUsers.length > 0) {
        if (this.actionItemSearchModel.visibleTrackIt == 0) {
          this.selectedItemsReminderUsers = this.removeElemetsFromArray(this.selectedItemsReminderUsers, $event.id)
          document.getElementById("openModalButton").click();
        }
        else {
          this.selectedItemsReminderUsers = this.removeElemetsFromArray(this.selectedItemsReminderUsers, $event.id)
          this.selectedItemsReminderUsers.push($event);
        }
      }
      else {
        this.selectedItemsReminderUsers.push($event);
      }
    }
  }

  removeElemetsFromArray(array, element) {
    return array.filter(e => e.id !== element);
  }
}
